/** Per-slot admin lock map from /api/client/first-month-risk-locks */
export function isSlotRiskLocked(locks, slot) {
  if (!locks || slot == null) return false;
  const n = Number(slot);
  if (!Number.isFinite(n) || n < 1) return false;
  return locks[n] === true || locks[String(n)] === true;
}
